import styled from 'styled-components'
import { ComboboxPopover, ComboboxOption } from '@dsny/dsny-component-library'

export const ComboboxPopoverStyled = styled(ComboboxPopover)`
  width: 100%;
  height: 216px;
  margin-top: 8px;
  background: ${({ theme }) => theme.colors.neutralW30};
  color: ${({ theme }) => theme.colors.neutralW100};
  border: 1px solid ${({ theme }) => theme.colors.neutralW40};
  border-radius: 5px;

  /* Styles for the WebKit scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* &::-webkit-scrollbar-track {
    background: #f1f1f1; 
  } */

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutralW50}}; 
  }

  /* &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  } */

  /* Styles for Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #717070 #f1f1f1; 
`

export const ComboboxOptionStyled = styled(ComboboxOption)`
  padding: 16px;
  color: ${({ theme }) => theme.colors.neutralW100}!important;

  &:hover {
    background: ${({ theme }) => theme.colors.neutralW40};
  }
`
